import axios from '../baseClient';
import {
    ConfigExtraResponse,
    ConfigRequest,
    ConfigResponse,
    RatesAndCUrrenciesRequestV2,
    RatesAndCUrrenciesResponse
} from './types';

class PaymentConverterService {
    private static domain = '/api/convertrateservice';

    getConfig(configRequest: ConfigRequest) {
        return axios.post<ConfigResponse>(`${PaymentConverterService.domain}/config`, configRequest);
    }

    getConfigExtra() {
        return axios.post<ConfigExtraResponse>(`${PaymentConverterService.domain}/configExtra`, {});
    }

    getRatesAndCUrrenciesV2(ratesAndCUrrenciesRequest: RatesAndCUrrenciesRequestV2) {
        return axios.post<RatesAndCUrrenciesResponse>(
            `${PaymentConverterService.domain}/ratesV2`,
            ratesAndCUrrenciesRequest
        );
    }

}

export default new PaymentConverterService();
